import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Splash } from "@/components/Protected";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  useEffect(() => {
    (async () => {
      await refresh();
      navigate("/", { replace: true });
    })();
  }, [refresh, navigate]);
  return <Splash />;
}
